/* unplugin-vue-components disabled */import script from "./UserProfileSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileSetting.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfileSetting.vue?vue&type=style&index=0&id=c84610fe&lang=stylus"

const __exports__ = script;

export default __exports__